import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { IMenu } from '@core/models';
import { NgIconsModule, provideIcons } from '@ng-icons/core';
import { heroChevronRightMini } from '@ng-icons/heroicons/mini';
import { SvgIconComponent } from '@shared/components';
import { HasRoleDirective } from '@shared/directives';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { animate, state, style, transition, trigger } from "@angular/animations";

interface SubMenuItem {
  label: string;
  route: string;
}

@Component({
  selector: 'app-menu-item-multi',
  templateUrl: './menu-item-multi.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MenuItemComponent,
    SvgIconComponent,
    HasRoleDirective,
    NgIconsModule,
  ],
  providers: [provideIcons({ heroChevronRightMini })],
  animations: [
    trigger('iconAnimation', [
      state('right', style({
        transform: 'rotate(0deg)'
      })),
      state('down', style({
        transform: 'rotate(90deg)'
      })),
      transition('right <=> down', animate('0.3s ease-in-out'))
    ]),
    trigger('slideDownUp', [
      state('void', style({
        opacity: 0,
        transform: 'translateY(-20px)'
      })),
      state('*', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition('void <=> *', animate('300ms ease-in-out'))
    ])
  ]
})
export class MenuItemMultiComponent {
  menuItem = input.required<IMenu>();

  showTemplate = signal<boolean>(false);
  iconState = signal<'down' | 'right'>('right');

  showItem() {
    this.showTemplate.update((value) => !value);
    this.iconState.set(this.showTemplate() ? 'down' : 'right');
  }
}
